export const RGBA_LENGTH = 4; // 4 components per pixel (RGBA)
export const MAX_POINTS_TO_SAMPLE = 2000; // For performance reasons, do not sample more than 2000 points when calculating suitability within one or more polygons
